import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileText, ArrowRight } from "lucide-react";

/**
 * Legacy ProjectDetail > Quotation tab. The new Quotations module lives at
 * /quotations and supports the full 3-page Dazlac template, templates, PDF
 * download and revisions. This panel offers a shortcut into it, pre-filling
 * from the current project.
 */
export function QuotationPanel({ projectId, leadId }) {
  const navigate = useNavigate();
  const open = () => navigate("/quotations/new", { state: { project_id: projectId, lead_id: leadId } });
  const openList = () => {
    const p = new URLSearchParams();
    if (projectId) p.set("project_id", projectId);
    if (leadId) p.set("lead_id", leadId);
    navigate(`/quotations?${p.toString()}`);
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-8 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-xl bg-blue-50 text-[#0057A8]"><FileText className="h-7 w-7" /></div>
      <h3 className="mt-4 text-lg font-semibold text-slate-900">Quotations have moved</h3>
      <p className="mt-1 text-sm text-slate-500">All quotations now live in the dedicated Quotations module with the 3-page Dazlac template, custom terms, revisions and PDF export.</p>
      <div className="mt-5 flex items-center justify-center gap-2">
        <Button variant="outline" onClick={openList} data-testid="open-quotations-list">Open Quotations</Button>
        <Button onClick={open} data-testid="new-quotation-for-project" className="gap-1.5 font-semibold">Create for this project <ArrowRight className="h-4 w-4" /></Button>
      </div>
    </div>
  );
}
